import { Controller } from "@hotwired/stimulus"

// Opens the accordion item a URL fragment points at, so links like
// /hunter/faqs#question14 land on an open answer instead of a collapsed row.
export default class extends Controller {
  connect() {
    this.open()
    this.onHashChange = () => this.open()
    window.addEventListener("hashchange", this.onHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange)
  }

  open() {
    const id = window.location.hash.slice(1)
    if (!id) return

    const header = this.element.querySelector(`#${CSS.escape(id)}`)
    if (!header) return

    const button = header.querySelector("[data-bs-target]")
    if (!button) return

    const answer = this.element.querySelector(button.dataset.bsTarget)
    if (!answer || answer.classList.contains("show")) return

    window.bootstrap.Collapse.getOrCreateInstance(answer, { toggle: false }).show()
    header.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
